<script lang="ts">
	import type { Address } from '../api/address';
	import { saveAddress, addressStore, addressNeedsGeocoding } from '../api/address.ts';
	import AddressSearch from './AddressSearch.svelte';
	import Button from './Button.svelte';
	import * as t from '../translations/Address.ts';

	export let selectedAddress: Address | null = null;
	export let editingAddress = false;
	export let lock = false;
	export let addressType;
	export let visibleAddressType;
	
	export let prefix;
	
	let disableContinueButton = false;
	// Callbacks
	export let onClearAddress = () => {};
	export let onSelectAddress = () => {};

	const setAddress = (addresses) => {
		if (visibleAddressType === addressType) {
			let address : Address;
			if (addresses) {
				address = addresses.get(addressType);
			}
			
			if (address?.streetAddress === undefined || address?.streetAddress === null ||
					address.zipCode === undefined || address.zipCode === null) {
				editingAddress = true;
				lock = false;
			} else if (lock === true) {
				editingAddress = false;
			}
			selectedAddress = address;

			if (selectedAddress?.checksum && !selectedAddress?.coordinates) {
				addressSearchElement?.addressChanged?.(address?.streetAddress, address?.zipCode, address?.city, address?.state);
			}
		}
	};
	
	$: setAddress($addressStore.addresses);

	let addressSearchElement: AddressSearch;
	async function selectAddress() {
		try {
			disableContinueButton = true;
			if (addressNeedsGeocoding(selectedAddress)) {
				await addressSearchElement?.addressChanged?.();
			}
			if (selectedAddress?.checksum) {
				editingAddress = false;
				
				selectedAddress.addressType = addressType;
				saveAddress(selectedAddress);

				$addressStore.selectedAddress = selectedAddress;
				$addressStore.addresses.set(selectedAddress.addressType, selectedAddress);
				
				onSelectAddress?.();
			}
		} finally {
			disableContinueButton = false;
		}
	}
	
	let addressHeader;
	$: addressHeader = ((prefix ?? '') + ' ' + t.Address()).trim();
</script>

{#if visibleAddressType === addressType}
	{#if lock || !editingAddress}
		<div>
			<span class="text-lg">{addressHeader}</span>
			{#if !lock}
				<button
						class="underline float-right hover:text-gray-600"
						title="{t.EditTooltip()}"
						on:click={() => (editingAddress = true)}
				>
					{t.Edit()}
				</button>
			{/if}
		</div>
		<div>
			{$addressStore.selectedAddress?.streetAddress}
		</div>
		<div>
			{$addressStore.selectedAddress?.city ? `${$addressStore.selectedAddress?.city},` : ``}
			{$addressStore.selectedAddress?.state}
			{$addressStore.selectedAddress?.zipCode}{$addressStore.selectedAddress?.zipCodeExtension
				? `-${$addressStore.selectedAddress?.zipCodeExtension}`
				: ''}
		</div>
	{:else}
		<AddressSearch class="mt-2"
					   bind:selectedAddress
					   bind:this={addressSearchElement}
					   {addressType}
					   {prefix}
					   {onClearAddress}
		></AddressSearch>
		<Button
			type="action-center"
			class="w-full mt-2"
			on:click={selectAddress}
			disabled={disableContinueButton}
		>
			{t.Continue()}
		</Button>
	{/if}
{/if}
